import { Navigate, useNavigate } from "react-router-dom";
import { WebshopLayout } from "@/components/layout/WebshopLayout";
import { CustomPlanView } from "@/components/result/CustomPlanView";
import { SpecifiedPlanView } from "@/components/result/SpecifiedPlanView";
import { findPlanDisplayedName, useCmsTherapyPlans } from "@/infra/hooks/useCmsTherapyPlans";
import { AppRoutes } from "@/infra/router";
import { useTreatmentSelectionStore } from "@/infra/stores/treatmentSelectionStore";

const CUSTOM_DESCRIPTION_MIN_LENGTH = 10;

export function ResultPage() {
  const navigate = useNavigate();
  const { universalPlan, plans } = useCmsTherapyPlans();

  const selectedTemplateKey = useTreatmentSelectionStore(s => s.selectedTemplateKey);
  const selectedBodyPart = useTreatmentSelectionStore(s => s.selectedBodyPart);
  const customDescription = useTreatmentSelectionStore(s => s.customDescription);
  const planDisplayedName = findPlanDisplayedName(plans, selectedTemplateKey);

  const isCustom =
    universalPlan != null && selectedTemplateKey === universalPlan.original_therapy_plan_key;
  const canContinue = isCustom ? customDescription.trim().length >= CUSTOM_DESCRIPTION_MIN_LENGTH : true;

  if (selectedBodyPart && selectedTemplateKey)
    return (
      <WebshopLayout
        footer={{
          onBack: () => navigate(AppRoutes.TreatmentSelection),
          onContinue: () => {
            if (!canContinue) return;
            navigate(AppRoutes.Checkout);
          },
          canContinue,
        }}>
        {isCustom ? (
          <CustomPlanView />
        ) : (
          <SpecifiedPlanView treatmentName={planDisplayedName || selectedBodyPart} />
        )}
      </WebshopLayout>
    );
  else {
    return <Navigate to={AppRoutes.TreatmentSelection} replace />;
  }
}
